import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	blockTitle: '',
	blockDesc: '',
	blockContent:
	  [
		  {
			  title: 'valival.bg',
			  desc: `
			  		<p>
			  			За мен superhosting.bg  е на първо място надеждност. 
			  			Днес много компании предлагат на пръв поглед идентични услуги, но истинската разлика е, че на вас може да се разчита. 
			  			Когато поемаме ангажимент към нашите партньори, за нас е важно хората зад нас също да могат да застанат зад тях. 
			  			Именно затова сме толкова щастливи, че сме ваши партньори.
			  		</p>
			  		<p>
			  			Димитър Иванов
					</p>
			  `,
			  descMobile: `
			  		<p>
			  			За мен superhosting.bg е на първо място надеждност. Истинският game changer е, че на вас може да се разчита.
			  		</p>
			  		<p>
			  			Димитър Иванов
					</p>
			  `
		  },
		  {
			  title: 'netpeak.bg',
			  desc: `
			  		<p>
						За мен superhosting.bg са приятни хора, приятели и партньори, с които се разбираме с един ред текст в support системата или просто по имейл. 
						Много рядко се налага да стигаме до телефонен разговор, което е показателно само по себе си. 
						Никога не съм усещал негативна нотка от ваша страна, a само разбиране и готовност за съдействие.
			  		</p>
			  		<p>
			  			Генадий Воробьов
					</p>
			  `,
			  descMobile: `
			  		<p>
						superhosting.bg са приятели и партньори, с които се разбираме с един ред текст през support системата.
			  		</p>
			  		<p>
			  			Генадий Воробьов
					</p>
			  `
		  },
		  {
			  title: 'ntwebsites.com',
			  desc: `
			  		<p>
						В началото търсехме надеждни партньори, към които спокойно да насочваме клиенти. 
						superhosting.bg  ни впечатли с качествена поддръжка и ефективно решаване на казуси. 
						С годините се доказахте като изключително надежден партньор и неслучайно работим заедно вече повече от 10 години. 
						Благодарим и за подкрепата към общности като WordPress и към младите хора в България.
			  		</p>
			  		<p>
			  			Николай Кръстев
					</p>
			  `,
			  descMobile: `
			  		<p>
						superhosting.bg ни впечатли с качествена поддръжка и решаване на казуси и се доказа като надежден партньор през годините.
			  		</p>
			  		<p>
			  			Николай Кръстев
					</p>
			  `
		  },
		  {
			  title: 'thesuperhumanpodcast.net',
			  desc: `
			  		<p>
						Аз съм създател на един от най-разпознаваемите подкасти в България и имам сайт единствено благодарение на подкрепата на superhosting.bg. 
						В продължение на години получавам съвети, съдействие и истинско съмишленичество. 
						Трудно ми е да изразя с думи благодарността си за постоянната подкрепа и отношението, което винаги е било лично и ангажирано.
			  		</p>
			  		<p>
			  			Георги Ненов
					</p>
			  `,
			  descMobile: `
			  		<p>
						Имам сайт благодарение на подкрепата на superhosting.bg и години наред получавам съвети, помощ и истинско съмишленичество.
			  		</p>
			  		<p>
			  			Георги Ненов
					</p>
			  `
		  },
		  {
			  title: 'optimiziraime.bg',
			  desc: `
			  		<p>
						Причините да работя със superhosting.bg  вече над 10 години са добрите условия, невероятният съпорт и хората, с които можеш да комуникираш по всяко време. 
						Независимо от казуса, поддръжката винаги е на разположение и реагира бързо и адекватно. 
						Това прави superhosting.bg  истински партньор, на когото можеш да разчиташ.
			  		</p>
			  		<p>
			  			Георги Манов
					</p>
			  `,
			  descMobile: `
			  		<p>
						Работя със SuperHosting над 10 години заради отличния съпорт, добрите условия и хората, на които можеш да разчиташ.
			  		</p>
			  		<p>
			  			Георги Манов
					</p>
			  `
		  }
	  ]
};

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: 'Success speaks for itself',
	blockDesc: 'Over 200,000 websites already rely on us. Here’s what some of our clients have to say.',
	blockContent:
	  [
		  {
			  title: 'valival.bg',
			  desc: `
			  		<p>
			  			For me, superhosting.bg  stands first and foremost for reliability. 
			  			Many companies today offer services that look identical on the surface, but the real difference is knowing you can rely on them. 
			  			When we commit to our partners, it matters to us that the people behind us can stand behind them as well. 
			  			That is why we are truly happy to be your partners.
			  		</p>
			  		<p>
			  			Dimitar Ivanov
					</p>
			  `,
			  descMobile: `
			  		<p>
			  			For me, superhosting.bg stands first and foremost for reliability. The real game changer is knowing you can rely on them.
			  		</p>
			  		<p>
			  			Dimitar Ivanov
					</p>
			  `
		  },
		  {
			  title: 'netpeak.bg',
			  desc: `
			  		<p>
						For me, superhosting.bg  is about kind people, friends, and partners with whom we understand each other through a single line of text in the support system or via email. 
						We rarely need to pick up the phone, which speaks for itself. 
						There has never been a negative tone from your side – only understanding and willingness to help.
			  		</p>
			  		<p>
			  			Genadiy Vorobyov
					</p>
			  `,
			  descMobile: `
			  		<p>
						superhosting.bg is about friends and partners we understand through a single line of text in the support system.
			  		</p>
			  		<p>
			  			Genadiy Vorobyov
					</p>
			  `
		  },
		  {
			  title: 'ntwebsites.com',
			  desc: `
			  		<p>
						In the beginning, we were looking for reliable partners we could confidently refer our clients to. 
						superhosting.bg  stood out with its high-quality support and effective case resolution. 
						Over the years, you have proven to be an exceptionally reliable partner, which is why we have been working together for more than 10 years. 
						Thank you for supporting communities such as WordPress and young people in Bulgaria.
			  		</p>
			  		<p>
			  			Nikolay Krastev
					</p>
			  `,
			  descMobile: `
			  		<p>
						superhosting.bg impressed us with its high-quality support and proved to be an exceptionally reliable partner over the years.
			  		</p>
			  		<p>
			  			Nikolay Krastev
					</p>
			  `
		  },
		  {
			  title: 'thesuperhumanpodcast.net',
			  desc: `
			  		<p>
						I am the creator of one of the most recognizable podcasts in Bulgaria and I have a website solely thanks to the support of superhosting.bg. 
						For many years, I have received guidance, help, and a true sense of partnership. 
						It is difficult to put into words my gratitude for the consistent support and the personal, committed attitude throughout the years.
			  		</p>
			  		<p>
			  			Georgi Nenov
					</p>
			  `,
			  descMobile: `
			  		<p>
						I have a website thanks to the support of superhosting.bg and for years I have received guidance, help, and true partnership.
			  		</p>
			  		<p>
			  			Georgi Nenov
					</p>
			  `
		  },
		  {
			  title: 'optimiziraime.bg',
			  desc: `
			  		<p>
						The reasons I have been working with superhosting.bg for over 10 years are the great terms, outstanding support, and the people you can communicate with at any time. 
						Regardless of the case, the support team is always available and responds quickly and professionally. 
						This makes superhosting.bg  not just a service provider, but a partner you can truly rely on.
			  		</p>
			  		<p>
			  			Georgi Manov
					</p>
			  `,
			  descMobile: `
			  		<p>
						I have worked with SuperHosting for over 10 years thanks to their outstanding support, great terms, and reliable people.
			  		</p>
			  		<p>
			  			Georgi Manov
					</p>
			  `
		  }
	  ]
};

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];